import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { map } from 'lodash/fp';

const S = {
  Signature: styled.div.attrs(({ position }) => ({
    style: {
      top: `${position.y}%`,
      left: `${position.x}%`,
    },
  }))`
    position: absolute;
    min-width: ${({ large }) => (large ? 120 : 80)}px;
    padding: ${({ large }) => (large ? '8px 16px 9px' : '3px 8px')};
    border-radius: 24px;
    color: ${({ theme }) => theme.palette.grey[900]};
    background-color: ${({ theme }) => theme.palette.status.note.background};
    font-size: ${({ large, theme }) => theme.typography.pxToRem(large ? 15 : 13)};
    font-weight: 500;
    text-align: right;
    line-height: 1.54;
    ::before {
      content: '';
      position: absolute;
      top: 50%;
      left: ${({ large }) => (large ? 12 : 8)}px;
      transform: translateY(-50%);
      width: ${({ large }) => (large ? 16 : 8)}px;
      height: ${({ large }) => (large ? 16 : 8)}px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.status.note.main};
    }
  `,
};

const SignatureRenderer = ({ children, large, signatures }) => signatures && (
  <ol>
    {map(signature => (
      <li key={signature.number}>
        <S.Signature position={signature.position} large={large}>
          {children}
        </S.Signature>
      </li>
    ), signatures)}
  </ol>
);

SignatureRenderer.propTypes = {
  children: PropTypes.node.isRequired,
  large: PropTypes.bool,
  signatures: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.number.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }),
  })),
};

SignatureRenderer.defaultProps = {
  large: false,
  signatures: null,
};

export default memo(SignatureRenderer);
